import { Pipe, PipeTransform } from '@angular/core';
import { HotelRoom } from '@sabstravtech/obtservices/angular';

@Pipe({
  name: 'orderHotelRoom',
  standalone: false
})
export class OrderHotelRoom implements PipeTransform {
  constructor() {}
  transform(rooms: HotelRoom[], ...args: any[]): HotelRoom[] {
    rooms.sort((a, b) => {
      if (a.total < b.total) {
        return -1;
      }
      if (a.total > b.total) {
        return 1;
      }
      return 0;
    });
    return rooms;
  }
}
